import './css/index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import ChartSelection from './selection';

export default class {

    static name = 'life-data-viz';

    constructor( config ) {

        Object.assign( this, config );

        this.pageWrapper = document.querySelector( '.page' );

        this.root = createRoot( this.element );

    }

    ready() {

        this.root.render(
            <ChartSelection
                pageWrapper={ this.pageWrapper }
                componentWrapper={ this.element }
                attributes={ this.attributes }
            />,
        );

    }

}
